const UI_STATE_TYPES = {
    LOADING: 'loading',
    EMPTY: 'empty',
    FILTERED_EMPTY: 'filteredEmpty',
};

export { UI_STATE_TYPES };
//# sourceMappingURL=UIState.types.js.map
